import {
  createCheckAuthorization,
  validateReverificationConfig
} from "./chunk-X3VKQCBG.mjs";
import "./chunk-7ELT755Q.mjs";
export {
  createCheckAuthorization,
  validateReverificationConfig
};
//# sourceMappingURL=authorization.mjs.map